import axios from "axios";

// `baseURL` is prepended to URLs passed to axios
axios.defaults.baseURL = '/';

// POST with JSON content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// `xsrfCookieName` is the name of the cookie
// to use as a value for xsrf token.
// Default is 'XSRF-TOKEN'
axios.defaults.xsrfCookieName = "CSRF-TOKEN";

// `xsrfHeaderName` is the name of the http header
// that carries the xsrf token value.
// Default is 'X-XSRF-TOKEN'
axios.defaults.xsrfHeaderName = "X-CSRF-Token";

// `withCredentials` indicates whether or not cross-site
// Access-Control requests should be made using credentials.
axios.defaults.withCredentials = true;

export default {
  getActivities() {
    return axios.get("/api/activities.json");
  },
  getTrash() {
    return axios.get("/api/tasks.json?trash=true");
  },
  getArchive() {
    return axios.get("/api/tasks.json?archive=true");
  },
  getNotes() {
    return axios.get("/api/notes.json");
  },
  getNote(id) {
    return axios.get("/api/notes/" + id + ".json");
  },
  createNote(params) {
    return axios.post("/api/notes.json", params)
  },
  updateNote(id, params) {
    return axios.patch("/api/notes/" + id + ".json", params);
  },
  deleteNote(id) {
    return axios.delete("/api/notes/" + id + ".json");
  },

  getTasks() {
    return axios.get("/api/tasks.json");
  },
  createTask(params) {
    return axios.post("/api/tasks.json", params)
  },
  updateTask(id, params) {
    return axios.patch("/api/tasks/" + id + ".json", params);
  },
  emailTask(id) {
    return axios.post("/api/tasks/" + id + "/email_task.json");
  },
  updateTaskContacts(id, params) {
    return axios.patch("/api/tasks/" + id + "/update_contacts.json", params);
  },
  updateAttachment(id, params) {
    return axios.patch("/api/tasks/" + id + "/update_attachment.json", params);
  },
  deleteAttachment(id, file_id) {
    return axios.patch("/api/tasks/" + id + "/delete_attachment.json", {file_id: file_id});
  },
  deleteTask(id) {
    return axios.delete("/api/tasks/" + id + ".json");
  },
  restoreTask(id) {
    return axios.patch("/api/tasks/" + id + "/undelete.json");
  },
  toggleTaskStatus(id, journaled = false) {
    return axios.patch("/api/tasks/" + id + "/toggle_status.json?journaled=" + journaled);
  },
  toggleTodayStatus(id){
    return axios.patch("/api/tasks/" + id + "/toggle_today.json");
  },

  createTaskItem(params) {
    return axios.post("/api/task_items.json", params)
  },
  updateTaskItem(id, params) {
    return axios.patch("/api/task_items/" + id + ".json", params);
  },
  deleteTaskItem(id) {
    return axios.delete("/api/task_items/" + id + ".json");
  },
  toggleTaskItemStatus(id) {
    return axios.patch("/api/task_items/" + id + "/toggle_status.json");
  },
  getProjects() {
    return axios.get("/api/projects.json");
  },
  getArchivedProjects() {
    return axios.get("/api/projects.json?trash=true");
  },
  getProject(id){
    return axios.get("/api/projects/" + id + ".json");
  },
  getProjectAreas() {
    return axios.get("/api/project_areas.json");
  },
  deleteProjectArea(id) {
    return axios.delete("/api/project_areas/" + id + ".json");
  },
  updateProjectArea(id, params) {
    return axios.patch("/api/project_areas/" + id + ".json", params);
  },
  createProject(params) {
    return axios.post("/api/projects.json", params)
  },
  deleteProject(id) {
    return axios.delete("/api/projects/" + id + ".json");
  },
  undeleteProject(id) {
    return axios.patch("/api/projects/" + id + "/undelete.json");
  },
  trashProject(id) {
    return axios.patch("/api/projects/" + id + "/trash.json");
  },
  untrashProject(id) {
    return axios.patch("/api/projects/" + id + "/untrash.json");
  },
  trashContact(id) {
    return axios.patch("/api/contacts/" + id + "/trash.json");
  },
  untrashContact(id) {
    return axios.patch("/api/contacts/" + id + "/untrash.json");
  },
  trashTag(id) {
    return axios.patch("/api/tags/" + id + "/trash.json");
  },
  untrashTag(id) {
    return axios.patch("/api/tags/" + id + "/untrash.json");
  },
  updateProject(id, params) {
    return axios.patch("/api/projects/" + id + ".json", params);
  },
  moveProject(id, new_project_area_id, new_sort){
    var params = {
      project_area_id: new_project_area_id,
      sort: new_sort
    }
    return axios.patch("/api/projects/" + id + ".json", params);
  },
  changeProjectSort(id, new_sort){
    return axios.patch("/api/projects/" + id + ".json", {sort: new_sort});
  },
  changeProjectAreaSort(id, new_sort){
    return axios.patch("/api/project_areas/" + id + ".json", {sort: new_sort});
  },  
  getTags(){
    return axios.get("/api/tags.json");
  },
  getActiveTags(){
    return axios.get("/api/tags/active.json");
  },
  getArchivedTags(){
    return axios.get("/api/tags/archived.json");
  },
  updateTag(tag, newTag, archived_at) {
    return axios.patch("/api/tags/" + encodeURIComponent(tag).replace(/\./g, '%2E') + ".json", {new_tag: newTag, archived_at: archived_at});
  },
  restoreTag(tagId) {
    return axios.patch("/api/tags/" + tagId + "/restore.json");
  },
  deleteTag(tag) {
    return axios.delete("/api/tags/" + encodeURIComponent(tag).replace(/\./g, '%2E') + ".json");
  },
  updateTagSort(tag_id, params) {
    return axios.patch("/api/tags/" + tag_id + "/update_sort.json", params);
  },
  getEvents(){
    return axios.get("/api/events.json");
  },
  getContacts(){
    return axios.get("/api/contacts.json");
  },
  getActiveContacts(){
    return axios.get("/api/contacts/active.json");
  },
  getArchivedContacts(){
    return axios.get("/api/contacts/archived.json");
  },
  archiveContact(id) {
    return axios.delete("/api/contacts/" + id + ".json");
  },
  unarchiveContact(id) {
    return axios.patch("/api/contacts/" + id + "/undelete.json");
  },
  createContact(name) {
    return axios.post("/api/contacts.json", {name: name});
  },
  updateContact(id, name) {
    return axios.patch("/api/contacts/" + id + ".json", {name: name});
  },
  updateContactSort(contact_id, params) {
    return axios.patch("/api/contacts/" + contact_id + "/update_sort.json", params);
  }, 
  getSortedGroups() {
    return axios.get("/api/sorted_groups.json");
  },
  getSortedGroup(name) {
    return axios.get("/api/sorted_groups/" + name + ".json");
  },
  updateSortedGroup(name, ordered_ids) {
    return axios.post("/api/sorted_groups", {name: name, ordered_ids: ordered_ids});
  },
  getGmailInbox(next) {
    return axios.get("/api/gmail.json?next=" + next)
  },
  moveGmailToInbox(id) {
    return axios.patch("/api/gmail/" + id + "/move_to_inbox.json")
  },
  moveTagToProject(tag_id, project_area_id) {
    return axios.patch("/api/projects/move_from_tag.json", {tag_id: tag_id, project_area_id: project_area_id})
  },
  moveProjectToTags(project_id) {
    return axios.patch("/api/tags/move_to_tag.json", {project_id: project_id})
  }
}
